import "./Footer.css";

export default function Footer() {
  return <footer className="footer mt-10"></footer>;
}
